import {waitTimeout} from "../../utils/wait-timeout";

export const mockNextNetworkingApis = {
    validateUrl: async ({url}) => {
        await waitTimeout(300);
        return url === "https://aa.com" ? {
            "success": true,
            "message": "URL is valid."
        } : {
            "success": false,
            "message": "URL is WRONG."
        };
    },
};

